import { createContext, useContext } from 'react';
import { ActiveType } from 'pages/get-started/add-your-team';
import { CreateEventFormType } from 'models/event.model';
import { GuestDetailsType } from 'models/guest.model';

export type EventDetailsContextType = {
  loading: boolean;
  setLoading: (value: boolean) => void;
  formData: CreateEventFormType;
  setFormData: (value: CreateEventFormType) => void;
  newGuestData: GuestDetailsType[];
  setNewGuestData: (value: GuestDetailsType[]) => void;
  active: ActiveType | null;
  setActive: (value: ActiveType) => void;
  disabled: boolean;
  setDisabled: (value: boolean) => void;
  isFormEmpty: boolean;
  setIsFormEmpty: (value: boolean) => void;
};
export const EventDetailsContext = createContext({} as EventDetailsContextType);

const useEventDetailsContext = () => {
  const context = useContext(EventDetailsContext);
  return context;
};

export default useEventDetailsContext;
